export default String.raw`
.comparison {
    &__bar {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 16px 130px;
        gap: 16px;
        background-color: #ffffff;
        box-shadow: 0px 8px 8px 0px #0000001F;
    }

    &__items {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
        margin-right: 16px;

        svg {
            margin: 2px;
        }

        .empty {
            fill: #959595;
        }
    }
}

`